import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import DiscountPolicyFormModal from 'src/features/discountPolicies/components/forms/DiscountPolicyFormModal';
import { useCreateDiscountPolicy } from 'src/features/discountPolicies/api/useCreateDiscountPolicy';
import { LIST_DISCOUNT_POLICIES_RESOURCE } from 'src/features/discountPolicies/api/useListDiscountPolicies';
import { DISCOUNT_POLICY_RESOURCE } from 'src/features/discountPolicies/api/useGetDiscountPolicy';
import { discountPoliciesMessages } from 'src/features/discountPolicies/utils/messages';

interface CreateDiscountPolicyFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateDiscountPolicyFormModal<TData>({ className, semantics }: CreateDiscountPolicyFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateDiscountPolicy({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_DISCOUNT_POLICIES_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [DISCOUNT_POLICY_RESOURCE] });
            toast({
                title: formatMessage(discountPoliciesMessages.createDiscountPolicySuccess),
                description: formatMessage(discountPoliciesMessages.createDiscountPolicySuccessDescription),
            });
        },
    });

    return (
        <DiscountPolicyFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(discountPoliciesMessages.addDiscountPolicySubtitle)}
        />
    );
}

export default CreateDiscountPolicyFormModal;
